import { module } from 'stereomodularjs';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        //button.js-show-more-events
        this.$showMoreEvents = this.el.querySelector('.js-show-more-events');
        if (!this.$showMoreEvents) return;
        this.$events = this.el.querySelectorAll('.js-event-item');

        // on click show all events
        this.$showMoreEvents.addEventListener('click', this.showMoreEvents.bind(this));
    }

    showMoreEvents(event) {
        // prevent default
        event.preventDefault();
        this.$events.forEach(event => {
            // remove style display none
            event.style.display = null;
        });

        // hide button
        this.$showMoreEvents.style.display = 'none';

        return false;
    }
}
